import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';
import { ToastService } from '@victory-lib-ui/shared/utils';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule, TranslocoDirective],
  template: `
    <ng-container *transloco="let t">
      <div
        class="toast-container position-fixed top-0 end-0 p-3"
        style="z-index: 9999;"
      >
        @for (toast of toastService.toasts(); track toast.id) {
        <div
          class="toast show align-items-center text-white border-0"
          [class.bg-success]="toast.type === 'success'"
          [class.bg-danger]="toast.type === 'error'"
          [class.bg-info]="toast.type === 'info'"
          [class.bg-warning]="toast.type === 'warning'"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div class="d-flex">
            <div class="toast-body">
              {{ t(toast.messageKey) }}
            </div>
            <button
              type="button"
              class="btn-close btn-close-white me-2 m-auto"
              (click)="toastService.dismiss(toast.id)"
              [attr.aria-label]="t('toast.closeAriaLabel')"
            ></button>
          </div>
        </div>
        }
      </div>
    </ng-container>
  `,
  styles: [
    `
      .toast {
        margin-bottom: 0.5rem;
        min-width: 250px;
      }
    `,
  ],
})
export class ToastContainerComponent {
  toastService = inject(ToastService);
}
